// EdgeLine — stateless SVG `<line>` between two logical coordinates.
//
// Direction is implicit: source is the manager, target is the report. We do
// not render an arrowhead in v1 — the halo on the current user and the
// vertical bias of the simulation make direction visually obvious without
// added clutter (see UX notes in the US4 spec).

import { GHOST_DASH } from './ghosts';

interface EdgeLineProps {
  /** Manager coordinate. */
  sourceX: number;
  /** Manager coordinate. */
  sourceY: number;
  /** Report coordinate. */
  targetX: number;
  /** Report coordinate. */
  targetY: number;
  /** Optional stroke override (defaults to the foreground colour at 0.85
   *  opacity — meant to be overridden with the manager's team colour). */
  stroke?: string;
  /** Optional opacity override. */
  opacity?: number;
  /** Optional stroke-width override. */
  strokeWidth?: number;
  /** Dash the line to signal a reporting line that leaves the P&E org
   *  (a ghost-manager edge). Defaults to a solid line. */
  dashed?: boolean;
}

export function EdgeLine({
  sourceX,
  sourceY,
  targetX,
  targetY,
  stroke = 'var(--color-foreground)',
  opacity = 0.85,
  strokeWidth = 1.5,
  dashed = false,
}: Readonly<EdgeLineProps>) {
  return (
    <line
      x1={sourceX}
      y1={sourceY}
      x2={targetX}
      y2={targetY}
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeOpacity={opacity}
      strokeDasharray={dashed ? GHOST_DASH : undefined}
      data-dashed={dashed ? 'true' : undefined}
      data-testid="edge-line"
    />
  );
}
